import React from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { classNames } from "primereact/utils";
import localeText from "../../../../locale";
import extraconomyLogoColorHorizontal from "../../../../pages/images/logo-color-horizontal.png";
import "../DashboardSidebar/DashboardSidebar.css";
import "./LegacyDashboardSidebar.css";

const MY_STORE_ITEMS = [
  { labelKey: "storeSettings", icon: "pi pi-cog", to: "/dashboard-store/settings" },
  { labelKey: "storeOrders", icon: "pi pi-clock", to: "/dashboard-store/orders" },
  { labelKey: "storeProducts", icon: "pi pi-shopping-bag", to: "/dashboard-store/products" },
  { labelKey: "storeSchedules", icon: "pi pi-calendar", to: "/dashboard-store/schedules" },
];

const LegacyDashboardSidebar = ({
  menuItems,
  userInfo,
  userTypeInfo,
  isMenuVisible,
  onMenuItemClick,
  onMenuButtonClick,
}) => {
  const history = useHistory();
  const location = useLocation();
  const showMyStore = location.pathname.startsWith("/dashboard-store");
  const visibleMyStoreItems = MY_STORE_ITEMS.filter(
    (item) => userTypeInfo !== "Customer" || item.to !== "/dashboard-store/settings"
  );

  const isDesktop = () => {
    return window.innerWidth > 896;
  };

  const getInitials = (firstname, surname) => {
    const first = firstname?.charAt(0)?.toUpperCase() || "";
    const second = surname?.charAt(0)?.toUpperCase() || "";
    return `${first}${second}` || "U";
  };

  const handleProfileClick = () => {
    history.push("/dashboard-editprofile");
  };

  const menuVisible = isMenuVisible();
  const desktop = isDesktop();

  const sidebarClassName = classNames("dashboard-sidebar", {
    "dashboard-sidebar-mobile-active": menuVisible && !desktop,
  });

  return (
    <div className={sidebarClassName}>
      <div className="dashboard-sidebar-logo">
        {!desktop && onMenuButtonClick && (
          <button
            className="dashboard-sidebar-menu-toggle"
            onClick={onMenuButtonClick}
            aria-label="Toggle menu"
          >
            <img src={extraconomyLogoColorHorizontal} alt="menu-icon" />
          </button>
        )}
        <button
          className="p-link"
          onClick={() =>
            history.push(
              JSON.parse(localStorage.getItem("__extraconomy_ismobile__") || "false")
                ? "/shop"
                : "/"
            )
          }
        >
          <img src={extraconomyLogoColorHorizontal} alt="extraconomy-logo" />
        </button>
      </div>
      <hr className="mb-2 mt-0 mx-3" />
      <div className="dashboard-sidebar-menu legacy-dashboard-sidebar-menu">
        <div className="dashboard-sidebar-menu-section">
          <h3 className="dashboard-sidebar-section-title">PRINCIPAL</h3>
          {showMyStore && (
            <div className="legacy-dashboard-sidebar-group">
              <div className="legacy-dashboard-sidebar-group-title">
                <span>{localeText("myStore")}</span>
              </div>
              <ul className="legacy-dashboard-sidebar-sublist">
                {visibleMyStoreItems.map((subitem, subIndex) => (
                  <li key={subitem.to} className="dashboard-sidebar-menu-item">
                    <NavLink
                      to={subitem.to}
                      className="dashboard-sidebar-menu-link"
                      activeClassName="dashboard-sidebar-menu-link-active"
                      onClick={(e) => onMenuItemClick && onMenuItemClick({ originalEvent: e })}
                    >
                      <i className={subitem.icon}></i>
                      <span>{localeText(subitem.labelKey)}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {menuItems.map((section, sectionIndex) => {
            if (!section.items || section.items.length === 0) return null;
            return (
              <div key={section.label || sectionIndex} className="legacy-dashboard-sidebar-group">
                <div className="legacy-dashboard-sidebar-group-title">
                  <span>{section.label}</span>
                </div>
                <ul className="legacy-dashboard-sidebar-sublist">
                  {section.items.map((subitem, subIndex) => (
                    <li key={subitem.to || subIndex} className="dashboard-sidebar-menu-item">
                      <NavLink
                        to={subitem.to}
                        exact={subitem.to === "/dashboard"}
                        className="dashboard-sidebar-menu-link"
                        activeClassName="dashboard-sidebar-menu-link-active"
                        onClick={(e) => {
                          if (onMenuItemClick) {
                            onMenuItemClick({ originalEvent: e, item: section });
                          }
                        }}
                      >
                        <i className={subitem.icon}></i>
                        <span>{subitem.label}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
      <hr className="mb-0 mt-2 mx-3" />
      {userInfo && (
        <div className="dashboard-sidebar-profile" onClick={handleProfileClick}>
          <div className="dashboard-sidebar-profile-avatar">
            {userInfo.urlAvatar ? (
              <img src={userInfo.urlAvatar} alt="user-avatar" />
            ) : (
              <div className="dashboard-sidebar-profile-initials">
                {getInitials(userInfo.firstname, userInfo.surname)}
              </div>
            )}
          </div>
          <div className="dashboard-sidebar-profile-info">
            <div className="dashboard-sidebar-profile-name">
              {userInfo.firstname} {userInfo.surname}
            </div>
            <div className="dashboard-sidebar-profile-role">{userTypeInfo}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LegacyDashboardSidebar;
